/**
 * The facet key and values the staff list's filter rail is built from.
 *
 * Internal identifiers, never shown - the heading the rail renders comes from `filterFacets` in
 * `staff-list.ts`, and the words beside the boxes come from the state-colour registry so they are
 * the same words the State column badges the rows with.
 *
 * THEY LIVE IN THEIR OWN MODULE BECAUSE THE JOURNEYS ADDRESS THE RAIL BY THEM, exactly as
 * `company-list-facets.ts` records for the company list. A journey that retyped `'access'` would
 * keep compiling after a rename and then fail on a timeout naming a missing checkbox rather than
 * naming the rename.
 *
 * Kept out of `staff-list.ts` for a mechanical reason as well: the Playwright suite is type-checked
 * under `tsconfig.e2e.json`, which is Node-side and carries no Vite client types, so importing the
 * page itself would pull `?inline` stylesheets and `import.meta.env` into a compilation that cannot
 * resolve any of them. A leaf module with no imports of its own is safe to read from either side.
 */

export const FACET_ACCESS = 'access';

/**
 * The operation-type facet: what a person IS by virtue of the sites they are assigned to. Its
 * values are the catalogue's domain codes, never a word, matching the company list's facet of the
 * same name (`company-list-facets.ts`).
 */
export const FACET_TYPES = 'types';

/**
 * Values of the access facet.
 *
 * `'blocked'`, not `'locked'`: `Login.Locked` is the stored flag, but the word this product has
 * shown for it since the state-colour registry is "Blocked", and an identifier that disagrees with
 * the label it renders is a trap for the next person reading the filter state in a debugger. This
 * is a new control with new values rather than a rename of a persisted one, so nothing migrates.
 */
export const ACCESS_ACTIVE = 'active';
export const ACCESS_BLOCKED = 'blocked';
